export const initialProductState = () => ({
  getAllProductLoading: false,
  getAllProductFailure: false,
  getAllProductLoaded: false,
});
